import { get, post } from "../utils/request";

// 选择NFT
//
// 1、type : 取值search（不传默认search）、send,
// type为get说明是获取用户是否发放过nft，send说明需要发放nft
const sendNFT = (data) => {
  return get("/user_bill/user_info/send_nft", data);
};

// 查询用户的
const getBill_Info = (data) => {
  return get("/user_bill/bill/info", data);
};

// 获取用户是否第一次访问年度账单
const getCheckVisit = (data) => {
  return get("/user_bill/user_info/check_visit", data);
};

// 记录/获取 用户访问过的地图
const getRecordVisit = (data) => {
  return get("/user_bill/user_info/record_visit", data);
};

// 没有用到，暂时注释
// const getUser_info = (data) => {
//      return get("/user_bill/user_info/info", data);
// }
// const getCopy_order_info = (data) => {
//      return get("/user_bill/copy_order/info", data);
// }
export {
  getBill_Info,
  sendNFT,
  // getUser_info,
  // getCopy_order_info,
  getCheckVisit,
  getRecordVisit,
};
